<!-- 佣金分配和审核 -->
<template>
  <div id="dealConfirmPartake">
    <div v-show="showButtons">
      <div class="editBtn" @click="toEditMode" v-if="!editMode">
        <pt-icon type="icon-bianji1" class="editIcon"></pt-icon>
      </div>
      <div v-else>
        <div style="display: flex; justify-content: flex-end;margin: 5px 0;">
          <!--<a-button @click="cancelEdit" style="margin-right: 10px;">{{$t('baseVO.cacel')}}</a-button>-->
          <!--<a-button @click="saveDealConfirmPartake" type="primary">{{$t('baseVO.save')}}</a-button>-->
        </div>
      </div>
    </div>

    <div v-if="!editMode">
      <div style="border: 1px solid #E7E7E7;margin:10px;">
        <a-row type="flex" class="parttake-row header">
          <a-col
              v-for="col in visibleColumns"
              :key="col.key"
              class="parttakeItem"
              :style="colStyle(col)"
          >
            {{ col.title }}
          </a-col>
        </a-row>

        <a-row
            v-for="(item, index) in defaultValue.dealConfrimPartakeDOList"
            :key="index"
            type="flex"
            class="parttake-row"
        >
          <a-col
              v-for="col in visibleColumns"
              :key="col.key"
              class="parttakeItem"
              :style="colStyle(col)"
              :class="col.key === 'name' ? 'col-name' : col.key === 'status' ? 'col-status' : 'col-money'"
          >
            <!-- ===== 账号 / 名称 ===== -->
            <template v-if="col.key === 'name'">
              <div class="name-wrap">
                <a-avatar
                    v-if="item.type === 1"
                    icon="user"
                    shape="circle"
                    :size="30"
                    :src="getHeadImg(item.accountId)"
                    style="margin-right:10px"
                />
                <span v-if="item.type === 2" style="margin-right:10px">
          <pt-icon style-obj="fontSize:30px" type="icon-disanfang" />
        </span>
                <span v-if="item.type === 3" style="margin-right:10px">
          <pt-icon style-obj="fontSize:30px" type="icon-shui" />
        </span>

                <a-tooltip placement="top" :title="item.name">
                  <span class="name-text">{{ item.name }}</span>
                </a-tooltip>
              </div>
            </template>

            <!-- ===== 逆比例 ===== -->
            <template v-else-if="col.key === 'inverse'">
              {{ item.inverseProportion }}%
            </template>

            <!-- ===== 税前金额 ===== -->
            <template v-else-if="col.key === 'amount'">
      <span v-if="!item.amountUnit || item.amountUnit == 0">
        {{ filterMoneyUnit(defaultValue.dealConfrimPartakeDOList[0].amountUnit) }}
      </span>
              <span v-else>
        {{ filterMoneyUnit(item.amountUnit) }}
      </span>
              <span>{{ item.beforeTaxAmount }}</span>
            </template>

            <!-- ===== 扣佣 ===== -->
            <template v-else-if="col.key === 'deduct'">
              <span v-if="item.type == 1">{{ item.deductCommission }}</span>
              <span v-else>~</span>
            </template>

            <!-- ===== 税后金额 ===== -->
            <template v-else-if="col.key === 'tax'">
              <template v-if="item.type == 1">
        <span v-if="!item.amountUnit || item.amountUnit == 0">
          {{ filterMoneyUnit(defaultValue.dealConfrimPartakeDOList[0].amountUnit) }}
        </span>
                <span v-else>
          {{ filterMoneyUnit(item.amountUnit) }}
        </span>
                <span v-if="defaultValue.overdueReceivable != '2'">
          {{ item.oldAmount }}
        </span>
                <span v-else>
          {{ item.amount }}
        </span>
              </template>
              <template v-else>~</template>
            </template>

            <!-- ===== 状态 ===== -->
            <template v-else-if="col.key === 'status'">
              <pt-tag
                  v-if="item.isConfirm == 1"
                  size="small"
                  color="grey"
                  :text="$t('deal.dealConfirm.dealConfirmPartake.isConfirmValue.' + item.isConfirm)"
              />
              <pt-tag
                  v-else
                  size="small"
                  :text="$t('deal.dealConfirm.dealConfirmPartake.isConfirmValue.' + item.isConfirm)"
              />
            </template>
          </a-col>
        </a-row>

      </div>
      <audit-detail :before-info='this.defaultValue' :type='10' :visable='false'></audit-detail>
      <div style="padding: 0 20px;">
        <div>
          {{$t('deal.dealConfirm.dealConfirmPartake.remarks')}}
        </div>
        <div>
          {{defaultValue.remarks}}
        </div>
      </div>

      <div v-if="defaultValue.dealConfirmFileVOS && defaultValue.dealConfirmFileVOS.length > 0 && showOtherFiles">
          <div slot="header" class="panel_header">
            <div class="panel_text">{{$t('commission.otherFiles')}}</div>
          </div>
          <a-row>
            <div class="fileDiv">
              <div >
                <div v-for="(item,index) in defaultValue.dealConfirmFileVOS" :key="index" class="fileItem">
                  <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
                  <div class="fileName">{{item.fileName}}</div>
                  <div @click="previewFile(item.fileId)"  v-if="$util.matchPreviewType(item.fileName)">
                    <pt-icon class="previewIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                  </div>
                  <div @click="downloadFile(item.fileId,item.fileName)" style="margin-left: 20px">
                    <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                  </div>
<!--                  <div @click="deleteDealConfirmFile(item)" v-if="showFunctionButton" style="margin-left: 20px">-->
<!--                    <pt-icon type="icon-tubiao" :styleObj="{fontSize: '14px', cursor:'pointer'}" :title="$t('baseVO.delete')"></pt-icon>-->
<!--                  </div>-->
                </div>
              </div>
              <!--<div v-else class="noFileClass">-->
              <!--<pt-empty><span slot="description">{{$t('baseVO.empty')}}</span></pt-empty>-->
              <!--</div>-->
            </div>
          </a-row>
      </div>



    </div>
    <div v-else>
      <a-form :form="dealConfirmPartakeForm">
        <a-row v-for="(d,index) in dealConfrimPartakeDOList" :key="index">
          <a-form-item v-show="false">
            <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].id`,{}]" disabled></a-input>
          </a-form-item>
          <a-form-item>
            <pt-input
              v-show="false"
              v-decorator="[`dealConfrimPartakeDOList[${index}].amountUnit`,{}]"></pt-input>
          </a-form-item>
          <a-form-item>
            <pt-input
              v-show="false"
              v-decorator="[`dealConfrimPartakeDOList[${index}].exchangedAmountUnit`,{}]"></pt-input>
          </a-form-item>
          <a-form-item>
            <pt-input
              v-show="false"
              v-decorator="[`dealConfrimPartakeDOList[${index}].exchangedAmount`,{}]"></pt-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].accountId`,{}]" disabled></a-input>
          </a-form-item>
          <a-col :span="8">
            <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.accountId') : null">
              <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].name`,{}]" disabled></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" v-if="defaultValue.allocationType == 1">
            <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.inverseProportion') : null">
              <pt-input-number @change="calculateAmount(index)"
                style="width:100%;"
                :max="100" :precision="2"
                v-decorator="[`dealConfrimPartakeDOList[${index}].inverseProportion`,{}]"></pt-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.amount') : null">
              <pt-input-number
                style="width:100%;"
                :max="9999999999" :precision="2"
                v-decorator="[`dealConfrimPartakeDOList[${index}].oldAmount`,{}]"></pt-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item v-show="false" :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.isConfirm') : null">
              <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].isConfirm`,{}]" disabled></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-form :form="dealConfirmForm">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('deal.dealConfirm.remarks')">
              <a-textarea :rows="3" v-decorator="decorators.remarks"></a-textarea>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </div>
</template>

<script>
  // import dealConfirmApi from '@/api/mine/dealConfirm'
  import { mapState } from 'vuex'
  import unitApi from '@/api/manager/unit'
  import dealConfirmAct from '@/api/mine/dealConfirmAct'
  import AuditDetail from '@/views/mine/expense/before/detail/audit'
  export default {
    name: 'dealConfirmPartake',
    components: { AuditDetail },
    props: {
      showButtons:{
        type:Boolean,
        default: true,
      },
      dealId:{
        type: String,
        default: null
      },
      visible:{
        type:Boolean,
        default: false
      },
      showOtherFiles:{
        type:Boolean,
        default: false
      },
      editMode:{
        type:Boolean,
        default: false
      },
      defaultValue:{
        type:Object,
        default: null
      },
    },
    computed:{
      ...mapState({
        unitVO: state => {
          let unitVO = state.user.units.find(o=>o.type == 2)
          return unitVO ? unitVO:{}
        }
      }),
      columns() {
        return [
          {
            key: 'name',
            title: this.$t('deal.dealConfirm.dealConfirmPartake.accountId'),
            show: true,
            ratio: 4, // 名称永远给最大
          },
          {
            key: 'inverse',
            title: this.$t('deal.dealConfirm.dealConfirmPartake.inverseProportion'),
            show: this.defaultValue.allocationType == 1,
            ratio: 1.5,
          },
          {
            key: 'amount',
            title: this.$t('deal.dealConfirm.dealConfirmPartake.amount'),
            show: true,
            ratio: 2,
          },
          {
            key: 'deduct',
            title: this.$t('key143'),
            show: this.defaultValue.overdueReceivable == 2,
            ratio: 2,
          },
          {
            key: 'tax',
            title: this.$t('deal.dealConfirm.dealConfirmPartake.taxRage'),
            show: true,
            ratio: 2,
          },
          {
            key: 'status',
            title: this.$t('deal.dealConfirm.dealConfirmPartake.isConfirm'),
            show: true,
            ratio: 2,
          },
        ]
      },

      visibleColumns() {
        return this.columns.filter(c => c.show)
      },

      totalRatio() {
        return this.visibleColumns.reduce((sum, c) => sum + c.ratio, 0)
      },
    },
    data() {
      return {
        unitAllData:[],
        dealConfirmFiles:[],
        panelStyle: 'background: #FFFFFF;border: 0;margin-bottom:10px !important;',
        totalComminssion: 0,
        dealConfrimPartakeDOList:[],
        dealConfirmPartakeForm: this.$form.createForm(this,{}),
        dealConfirmForm: this.$form.createForm(this,{}),
        decorators:{
          payer:['payer',{}],
          commissionRate:['commissionRate',{}],
          totalComminssion:['totalComminssion',{}],
          remarks:['remarks',{}]
        }
      }
    },
    mounted() {
      this.init()
      console.log("defaultValue",this.defaultValue)
    },
    methods: {
      colStyle(col) {
        const percent = (col.ratio / this.totalRatio) * 100
        return {
          flex: `0 0 ${percent}%`,
          minWidth: 0,
        }
      },
      previewFile(fileId){
        this.$util.previewFile(fileId)
      },
      downloadFile(id,fileName){
        this.$util.dowLoadFile(id,fileName,this);
      },
      filterMoneyUnit(id){
        let curUnit = this.unitAllData.find(data =>{
          return data.id == id
        })
        return curUnit ? curUnit.charts:'';
      },
      initAllUnit(){
        unitApi.selectAll().then(res=>{
          if(res.code == 1){
            this.unitAllData= res.data ? res.data:[]
          }
        })
      },
      cancelEdit(){
        this.editMode = false
      },
      calculateAmount(index){
        this.$nextTick(()=>{
          let dealConfirmPartakeForms = this.dealConfirmPartakeForm.getFieldsValue()
          let percent = dealConfirmPartakeForms.dealConfrimPartakeDOList[index].inverseProportion
          let totalComminssion = 0
          if(typeof this.totalComminssion == "number"){
            totalComminssion = this.totalComminssion
          }else{
            totalComminssion = parseFloat(this.totalComminssion.replace(/,/g,''))
          }
          if(index < (dealConfirmPartakeForms.dealConfrimPartakeDOList.length - 1)){
            let amount = totalComminssion * percent / 100
            dealConfirmPartakeForms.dealConfrimPartakeDOList[index].amount = amount
            this.dealConfirmPartakeForm.setFieldsValue(dealConfirmPartakeForms)
          }else{
            let subAmout = 0;
            dealConfirmPartakeForms.dealConfrimPartakeDOList.forEach((data,idx)=>{
              if(index != idx){
                subAmout = subAmout + data.amount;
              }
            })

            let amount = totalComminssion - subAmout;
            dealConfirmPartakeForms.dealConfrimPartakeDOList[index].amount = amount
            this.dealConfirmPartakeForm.setFieldsValue(dealConfirmPartakeForms)
          }

        })
      },
      extractForms(){
        let dealConfirmForm = this.dealConfirmForm.getFieldsValue()
        let dealConfirmPartakeForms = this.dealConfirmPartakeForm.getFieldsValue()
        return {dealConfirmForm,dealConfirmPartakeForms}
      },
      hide(){
        this.$emit('hide')
      },
      getHeadImg(userId){
        console.log(userId)
        return this.$util.getHeadImgUrl(userId)
      },


      getAct(){

      console.log('asdasda',this.defaultValue.dealConfirmActList)
        // dealConfirmAct.selectByDealId(this.defaultValue.dealId).then(res=>{
        //   console.log(res)
        // })
      },

      init(){
        this.initAllUnit();
        this.getAct();
        // this.selectDealConfirmVO()
      },
      // selectDealConfirmVO(){
      //   if(this.dealId){
      //     dealConfirmApi.selectByDealId(this.dealId).then(res=>{
      //       if(res.code == 1){
      //         this.dealConfrimPartakeDOList = res.data.dealConfrimPartakeDOList
      //         this.$nextTick(()=>{
      //           this.dealConfirmPartakeForm.setFieldsValue(res.data)
      //           this.dealConfirmForm.setFieldsValue(res.data)
      //         })
      //       }
      //     })
      //   }
      // },
      toEditMode(){
        this.editMode = true
        this.refreshFormWithDefaultValue()
      },
      toViewMode(){
        this.editMode = false
      },
      // saveDealConfirmPartake(){
      //   let dealConfirmVO = this.dealConfirmForm.getFieldsValue()
      //   dealConfirmVO.dealConfrimPartakeDOList = this.dealConfirmPartakeForm.getFieldsValue().dealConfrimPartakeDOList
      //   dealConfirmApi.updateDealConfirmPartake(dealConfirmVO).then(res=>{
      //     if(res.code == 1){
      //       this.cancelEdit()
      //       this.$emit('refresh')
      //     }else{
      //
      //     }
      //   })
      // },
      initByDefaultValue(){
        this.totalComminssion = this.defaultValue.totalComminssion
        this.dealConfrimPartakeDOList = this.defaultValue.dealConfrimPartakeDOList
        this.$nextTick(()=>{
          this.dealConfirmPartakeForm.setFieldsValue(this.defaultValue)
        })
      },
      refreshFormWithDefaultValue(dealConfirmDO){
        let dealConfrimPartakeDOList = this.dealConfirmPartakeForm.getFieldsValue()
        let totalCommission = dealConfirmDO.totalComminssion
        this.totalComminssion = dealConfirmDO.totalComminssion
        dealConfrimPartakeDOList.dealConfrimPartakeDOList.forEach(e=>{
          e.amount = totalCommission * e.inverseProportion / 100
        })
        this.$nextTick(()=>{
          this.dealConfirmPartakeForm.setFieldsValue(dealConfrimPartakeDOList)
        })
      }
    },
    watch:{
      // defaultValue(){
      //   this.refreshFormWithDefaultValue()
      // }
    }
  }
</script>

<style scoped lang="less">
.parttake-row {
  border-top: 1px solid #e7e7e7;
}

.parttakeItem {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 12px;
  min-width: 0;
}

.col-name {
  justify-content: flex-start;
}

.name-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
}

.name-text {
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.col-money {
  justify-content: flex-start;
}

.fileDiv{
  margin-top: 10px;
  padding: 0 20px;
  border-radius: 0 0 4px 4px;
}
.fileItem{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #E7E7E7;
  .fileIcon{
    font-size: 18px;
  }
  .fileName{
    flex:1;
    font-size: 12px;
    color: #333333;
    margin: 0 10px;
    display: flex;
    align-items: center;
  }
  .delIcon{
    font-size: 20px;
    cursor: pointer;
  }
}
.fileItem:last-child{
  border-bottom: 0px;
}
.panel_header{
  margin-top: 30px;
  display: flex;
  align-items: center;
  .circle{
    margin-left: 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #FABE00;
  }
  .panel_text{
    padding: 0 10px;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
  }
}

.col-status {
  justify-content: flex-start;
}


</style>